import React from "react";
import { Button } from "@shadcn-in-nx/ui/button";
import { ShieldCheck, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

function CodeScanHeader({ scanResult, isScanning, onRunScan, disabled }) {
    const { t } = useTranslation();

    const statusBadge = React.useMemo(() => {
        if (!scanResult) return null;
        const map = {
            PENDING: { label: t("appPreview.statusPending"), color: "bg-gray-100 text-gray-700" },
            RUNNING: { label: t("appPreview.statusRunning"), color: "bg-blue-100 text-blue-700" },
            COMPLETED: { label: t("appPreview.statusCompleted"), color: "bg-green-100 text-green-700" },
            FAILED: { label: t("appPreview.statusFailed"), color: "bg-red-100 text-red-700" },
        };
        return map[scanResult.status] || null;
    }, [scanResult, t]);

    return (
        <div className="flex items-center justify-between p-4 border-b">
            <div className="flex items-center gap-3">
                <ShieldCheck className="w-5 h-5 text-gray-700" />
                <h2 className="text-lg font-semibold text-gray-900">
                    {t("appPreview.codeScanning") || "Code Scanning"}
                </h2>
                {statusBadge && (
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${statusBadge.color}`}>
                        {statusBadge.label}
                    </span>
                )}
            </div>
            <div className="flex items-center gap-3">
                {scanResult?.completedAt && (
                    <span className="text-xs text-gray-500">
                        {new Date(scanResult.completedAt).toLocaleString()}
                    </span>
                )}
                <Button
                    size="sm"
                    onClick={onRunScan}
                    disabled={isScanning || disabled}
                >
                    {isScanning ? (
                        <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                    ) : (
                        <ShieldCheck className="w-4 h-4 mr-1" />
                    )}
                    {isScanning
                        ? t("appPreview.scanning") || "Scanning..."
                        : t("appPreview.runScan") || "Run Scan"}
                </Button>
            </div>
        </div>
    );
}

export default React.memo(CodeScanHeader);
